import { Component } from '@angular/core';

@Component({
  selector: 'app-listagem-vazia',
  templateUrl: './listagem-vazia.component.html',
  styleUrls: ['./listagem-vazia.component.scss']
})
export class ListagemVaziaComponent {}
